import React, { useContext, useState } from "react";
import SpeakerIcon from '@mui/icons-material/Speaker'
import FastfoodIcon from '@mui/icons-material/Speaker'
import PictureInPictureAltIcon from '@mui/icons-material/PictureInPictureAlt';
import FlightIcon from '@mui/icons-material/Flight';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import Grid from '@mui/material/Grid'; // Grid version 1
import AdminSingleCard from "./AdminSingleCard";
import { AppContext } from "../../App";

export default function AdminDocuments(){

  return (
    <div className="admin-docs">
      <h3>Artist Documents</h3>
      <Grid container spacing={0.5}>
          <Grid sx={{padding: '0.5em'}} xs={6} item={true}>
            <AdminSingleCard dbName="techRider" icon={<SpeakerIcon sx={{fontSize:'3em'}}/>} title="Technical Rider"/>
          </Grid>
          <Grid sx={{padding: '0.5em'}} xs={6} item={true}>
            <AdminSingleCard dbName="hospitalityRider" icon={<FastfoodIcon sx={{fontSize:'3em'}}/>} title="Hospitality Rider"/>
          </Grid>
          <Grid sx={{padding: '0.5em'}} xs={6} item={true}>
            <AdminSingleCard dbName="stagePlan" icon={<PictureInPictureAltIcon sx={{fontSize:'3em'}}/>} title="Stage Plan"/>
          </Grid>
          <Grid sx={{padding: '0.5em'}} xs={6} item={true}>
            <AdminSingleCard dbName="pressPhotos" icon={<CameraAltIcon sx={{fontSize:'3em'}}/>} title="Press Photos"/>
          </Grid>
        </Grid>
    </div>
  )
}